import { render } from "./ListaMapas.vue?vue&type=template&id=9bfce41e&scoped=true"
import script from "./ListaMapas.vue?vue&type=script&lang=js"
export * from "./ListaMapas.vue?vue&type=script&lang=js"

import "./ListaMapas.vue?vue&type=style&index=0&id=9bfce41e&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfce41e"]])

export default __exports__